import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import NewProjectService from '../../../Services/NewProjectService';
import ProjectPlatformCostOverrideItem from '../../../Domain/ThirdParty/Project/ProjectPlatformCostOverrideItem';

class PlatformCostOverrideWindowDescription extends React.Component {
  static titleForCreate = 'Add Platform Cost Override';
  static titleForEdit = 'Edit Platform Cost Override';
  static ComponentName = 'PlatformCostOverride';
  static itemType = ProjectPlatformCostOverrideItem;
  static messageOnSuccess = 'Platform cost override has been saved.';
  // The indefinite (∞) end date means open-ended — the backend stores it as no end date at all.
  static serviceFunction = (edited) => {
    const payload = { ...edited, EndDate: dateTimeHelper.isIndefinite(edited.EndDate) ? '' : edited.EndDate };
    return NewProjectService.UpsertPlatformCostOverride(payload);
  };
  static deleteFunction = (edited) => NewProjectService.DeletePlatformCostOverride(edited.ProjectId);
  static deleteConfirmMessage = 'Are you sure you want to delete this platform cost override?';
  static messageOnDelete = 'Platform cost override has been deleted.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'AmountUsd',
          label: 'Override Fee (USD) *',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'EffectiveFromDate',
          label: 'Effective From (applies from the 1st of that month) *',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: PlatformCostOverrideWindowDescription.validityCheckerForEffectiveFrom,
        },
        {
          fieldName: 'EndDate',
          label: 'End Date (∞ = runs to the end of the project)',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: PlatformCostOverrideWindowDescription.validityCheckerForEndDate,
        },
      ],
    },
  ];

  static validityCheckerForEffectiveFrom(e, editedItem) {
    if (!e) {
      return 'The effective-from date is required.';
    }
    if (editedItem && !editedItem.IsNewOverride) {
      // On edit the backend allows keeping the stored (possibly past) month and
      // authoritatively rejects moving to a different past month.
      return '';
    }
    const selected = new Date(e);
    const now = new Date();
    const selectedMonth = selected.getFullYear() * 12 + selected.getMonth();
    const currentMonth = now.getFullYear() * 12 + now.getMonth();
    return selectedMonth < currentMonth ? 'The effective-from month cannot be in the past.' : '';
  }

  static validityCheckerForEndDate(e, editedItem) {
    if (!e || dateTimeHelper.isIndefinite(e)) {
      return '';
    }
    if (editedItem && editedItem.EffectiveFromDate && new Date(e) < new Date(editedItem.EffectiveFromDate)) {
      return 'The end date cannot be earlier than the effective-from date.';
    }
    return '';
  }
}

export default PlatformCostOverrideWindowDescription;
